export default __webpack_public_path__ + "fonts/worry-img2.svg";